export type DashboardBooking = {
  id: string;
  service: string;
  serviceIcon: string;
  date: string; // ISO yyyy-mm-dd
  time: string;
  duration: string;
  cleanerId: string;
  cleanerName: string;
  cleanerImage: string;
  address: string;
  status: "upcoming" | "in_progress" | "completed" | "cancelled";
  total: number;
  frequency: string;
  addOns: string[];
  rating?: number;
  review?: string;
};

export const upcomingBookings: DashboardBooking[] = [
  {
    id: "bk-2041",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-line",
    date: "2026-06-19",
    time: "9:30 AM",
    duration: "≈ 3.5 hrs",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20portrait%20smiling%20warmly%20clean%20olive%20green%20apron%20soft%20cream%20background%20editorial%20natural%20warm%20light%20approachable&width=240&height=240&seq=dash-maya-01&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "upcoming",
    total: 174,
    frequency: "Bi-weekly",
    addOns: ["Laundry & folding"],
  },
  {
    id: "bk-2052",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    date: "2026-07-03",
    time: "11:00 AM",
    duration: "≈ 6 hrs",
    cleanerId: "daniel",
    cleanerName: "Daniel Reyes",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Confident%20professional%20male%20house%20cleaner%20portrait%20smiling%20kindly%20beige%20uniform%20soft%20cream%20background%20editorial%20natural%20warm%20light%20friendly%20reliable&width=240&height=240&seq=dash-daniel-01&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "upcoming",
    total: 314,
    frequency: "One-time",
    addOns: ["Inside oven", "Inside fridge"],
  },
];

export const pastBookings: DashboardBooking[] = [
  {
    id: "bk-1998",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-line",
    date: "2026-06-05",
    time: "10:00 AM",
    duration: "3.5 hrs",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20cleaner%20portrait%20olive%20apron%20cream%20background%20warm%20editorial&width=240&height=240&seq=dash-maya-02&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "completed",
    total: 169,
    frequency: "Bi-weekly",
    addOns: ["Laundry & folding"],
    rating: 5,
    review: "Maya is a wizard. Place smells like a spa. Will book again.",
  },
  {
    id: "bk-1985",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-line",
    date: "2026-05-22",
    time: "9:30 AM",
    duration: "3 hrs",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Female%20cleaner%20portrait%20warm%20friendly%20smile%20olive%20apron%20natural%20light%20cream%20background&width=240&height=240&seq=dash-maya-03&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "completed",
    total: 169,
    frequency: "Bi-weekly",
    addOns: [],
    rating: 5,
  },
  {
    id: "bk-1972",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    date: "2026-05-08",
    time: "8:00 AM",
    duration: "6.5 hrs",
    cleanerId: "aisha",
    cleanerName: "Aisha Bennett",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Female%20eco%20cleaner%20portrait%20sage%20apron%20warm%20friendly%20smile%20cream%20background%20editorial&width=240&height=240&seq=dash-aisha-01&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "completed",
    total: 289,
    frequency: "One-time",
    addOns: ["Interior windows", "Inside cabinets"],
    rating: 5,
    review: "Aisha reorganized my spice rack. Unprompted. I love her.",
  },
  {
    id: "bk-1960",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-line",
    date: "2026-04-24",
    time: "10:00 AM",
    duration: "3 hrs",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Female%20house%20cleaner%20olive%20apron%20warm%20portrait%20editorial%20natural%20warm%20light%20cream&width=240&height=240&seq=dash-maya-04&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "completed",
    total: 149,
    frequency: "Bi-weekly",
    addOns: [],
    rating: 4,
  },
  {
    id: "bk-1947",
    service: "Airbnb Turnover",
    serviceIcon: "ri-key-2-line",
    date: "2026-04-10",
    time: "12:30 PM",
    duration: "2.5 hrs",
    cleanerId: "jonah",
    cleanerName: "Jonah Park",
    cleanerImage:
      "https://readdy.ai/api/search-image?query=Male%20cleaner%20portrait%20olive%20uniform%20warm%20friendly%20smile%20cream%20background%20editorial%20natural%20light&width=240&height=240&seq=dash-jonah-01&orientation=squarish",
    address: "147 Linden Ave · Apt 3B · Brooklyn, NY",
    status: "completed",
    total: 119,
    frequency: "One-time",
    addOns: [],
    rating: 5,
    review: "Quiet, fast, surgical. Guests left a 5-star review.",
  },
];

export type FavoriteCleaner = {
  id: string;
  name: string;
  role: string;
  rating: number;
  bookings: number;
  lastBooked: string;
  rate: number;
  bio: string;
  tags: string[];
  image: string;
  nextAvailable: string;
};

export const favoriteCleaners: FavoriteCleaner[] = [
  {
    id: "maya",
    name: "Maya Olsen",
    role: "Senior Cleaner",
    rating: 4.96,
    bookings: 8,
    lastBooked: "Jun 5, 2026",
    rate: 32,
    bio: "Six years with PureNest. Lives for a perfectly streak-free kitchen.",
    tags: ["Eco products", "Pet-friendly", "English · Norwegian"],
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20smiling%20warmly%20clean%20olive%20green%20apron%20soft%20cream%20studio%20background%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable&width=600&height=720&seq=dash-fav-maya&orientation=portrait",
    nextAvailable: "Thu, Jun 19 · 9:30 AM",
  },
  {
    id: "aisha",
    name: "Aisha Bennett",
    role: "Eco Clean Lead",
    rating: 5.0,
    bookings: 2,
    lastBooked: "May 8, 2026",
    rate: 34,
    bio: "Plant-based products only. Will quietly reorganize your spice rack.",
    tags: ["100% eco", "Plant-based", "English"],
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20eco%20cleaner%20warm%20smile%20sage%20green%20apron%20soft%20cream%20studio%20background%20editorial%20portrait%20photography%20natural%20warm%20light&width=600&height=720&seq=dash-fav-aisha&orientation=portrait",
    nextAvailable: "Sat, Jun 21 · 11:00 AM",
  },
  {
    id: "jonah",
    name: "Jonah Park",
    role: "Studio & Airbnb Pro",
    rating: 4.9,
    bookings: 3,
    lastBooked: "Apr 10, 2026",
    rate: 31,
    bio: "Fast, quiet, surgical. Hosts love him. Lives for tight turnovers.",
    tags: ["Fast turnover", "Linen reset", "English · Korean"],
    image:
      "https://readdy.ai/api/search-image?query=Professional%20male%20cleaner%20warm%20friendly%20smile%20clean%20olive%20uniform%20soft%20cream%20studio%20background%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable&width=600&height=720&seq=dash-fav-jonah&orientation=portrait",
    nextAvailable: "Fri, Jun 20 · 8:00 AM",
  },
];

export type PaymentMethod = {
  id: string;
  brand: string;
  last4: string;
  expiry: string;
  holder: string;
  isDefault: boolean;
  color: string; // gradient class set
};

export const paymentMethods: PaymentMethod[] = [
  {
    id: "pm-1",
    brand: "Visa",
    last4: "4242",
    expiry: "08 / 28",
    holder: "Eleanor Hayes",
    isDefault: true,
    color: "from-primary-700 to-primary-900",
  },
  {
    id: "pm-2",
    brand: "Mastercard",
    last4: "8821",
    expiry: "11 / 27",
    holder: "Eleanor Hayes",
    isDefault: false,
    color: "from-accent-600 to-accent-800",
  },
];

export type Invoice = {
  id: string;
  number: string;
  date: string;
  service: string;
  amount: number;
  method: string;
  status: "paid" | "pending" | "refunded";
};

export const invoices: Invoice[] = [
  {
    id: "in-2041",
    number: "INV-2041",
    date: "Jun 19, 2026",
    service: "Standard Clean · Maya O.",
    amount: 174,
    method: "Visa · 4242",
    status: "pending",
  },
  {
    id: "in-1998",
    number: "INV-1998",
    date: "Jun 5, 2026",
    service: "Standard Clean · Maya O.",
    amount: 169,
    method: "Visa · 4242",
    status: "paid",
  },
  {
    id: "in-1985",
    number: "INV-1985",
    date: "May 22, 2026",
    service: "Standard Clean · Maya O.",
    amount: 169,
    method: "Visa · 4242",
    status: "paid",
  },
  {
    id: "in-1972",
    number: "INV-1972",
    date: "May 8, 2026",
    service: "Deep Clean · Aisha B.",
    amount: 289,
    method: "Visa · 4242",
    status: "paid",
  },
  {
    id: "in-1960",
    number: "INV-1960",
    date: "Apr 24, 2026",
    service: "Standard Clean · Maya O.",
    amount: 149,
    method: "Mastercard · 8821",
    status: "paid",
  },
  {
    id: "in-1947",
    number: "INV-1947",
    date: "Apr 10, 2026",
    service: "Airbnb Turnover · Jonah P.",
    amount: 119,
    method: "Mastercard · 8821",
    status: "paid",
  },
  {
    id: "in-1933",
    number: "INV-1933",
    date: "Mar 27, 2026",
    service: "Standard Clean · Maya O.",
    amount: 149,
    method: "Visa · 4242",
    status: "refunded",
  },
];

export const dashboardNavLinks = [
  { to: "/dashboard", label: "Overview", icon: "ri-dashboard-line", end: true },
  { to: "/dashboard/bookings", label: "Bookings", icon: "ri-calendar-check-line" },
  { to: "/dashboard/cleaners", label: "Favorite cleaners", icon: "ri-user-heart-line" },
  { to: "/dashboard/billing", label: "Billing", icon: "ri-bank-card-line" },
];

export const recentActivity = [
  {
    id: "ac-1",
    icon: "ri-calendar-check-line",
    title: "Booking confirmed",
    description: "Standard Clean with Maya Olsen on Jun 19",
    time: "2 hours ago",
    tone: "primary" as const,
  },
  {
    id: "ac-2",
    icon: "ri-star-line",
    title: "You left a 5-star review",
    description: "Aisha Bennett · Deep Clean from May 8",
    time: "Yesterday",
    tone: "accent" as const,
  },
  {
    id: "ac-3",
    icon: "ri-bank-card-line",
    title: "Payment received",
    description: "$169 charged to Visa ending 4242",
    time: "Jun 5",
    tone: "secondary" as const,
  },
  {
    id: "ac-4",
    icon: "ri-user-heart-line",
    title: "Added to favorites",
    description: "You favorited Jonah Park",
    time: "Apr 10",
    tone: "primary" as const,
  },
];